module.exports = __webpack_public_path__ + "chefy-america-civics.png?6e154a3d280886f067efbf83b9dd6ee9";


//////////////////
// WEBPACK FOOTER
// ./src/assets/chefy-america-civics.png
// module id = 34
// module chunks = 0